/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortOrderDTO {
    ASC = 'ASC',
    DESC = 'DESC',
}
